import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// import saveAs from 'file-saver';

import i18next from 'i18next'

import { setVerifyInputData, setMacPasses, setGlobalProcessing, setVerifyResultsArray, setIndexiesArray, setWithAuSigVerificationResultArray, setShowedObjectsArray,
		 setShowErrorPopup, setErrorData } from "../actions/localStates"
import { verifierFull, getProtectedParams } from "../actions/api"
import { cipher, formatDate } from "../actions/helpers"

// import { jsPDF } from "jspdf";

import Dropzone from 'react-dropzone';
const dropzoneDocRef = createRef();
// const dropzoneImageRef = createRef();


class VerifyDSView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {

	    }

	    this.handleOnDropData = this.handleOnDropData.bind(this)
	    this.handleMacPassesChanged = this.handleMacPassesChanged.bind(this)

	    this.isEmpty = this.isEmpty.bind(this)

	    this.keyUpHandler = this.keyUpHandler.bind(this, 'verifyDS');
	}

	handleOnDropData (files) {
		this.props.actions.setVerifyInputData(files[0])
	}

	handleMacPassesChanged (e) {
		const input = e.target.value;

		const regex = /^(?!.* {2})[\p{L}\d ]*$/u;

		if (regex.test(input)) {
			this.props.actions.setMacPasses(input)
		}
	}

	changeShowedState (index) {
		var tempArr = this.props.verifyDSReducer.showedObjectsArray
		if (tempArr[index] === "") {
			tempArr[index] = "show"
		} else {
			tempArr[index] = ""
		}

		this.props.actions.setShowedObjectsArray(tempArr)
		console.log(tempArr)
	}

	cleanUpForm () {
		this.props.actions.setVerifyInputData(null)
		this.props.actions.setMacPasses("")
		this.props.actions.setVerifyResultsArray([])
    	this.props.actions.setIndexiesArray([])
		this.props.actions.setWithAuSigVerificationResultArray([])
		this.props.actions.setShowedObjectsArray([])
	}

	formatDateDS(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit",
            "timeZoneName": "short"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

	verifyDS () {
		var b64string, _this = this;

		this.props.actions.setVerifyResultsArray([])
    	this.props.actions.setIndexiesArray([])
		this.props.actions.setWithAuSigVerificationResultArray([])
		this.props.actions.setShowedObjectsArray([])
		
		this.props.actions.setGlobalProcessing(true)
		
		function readFile(file) {
		  return new Promise((resolve, reject) => {
		    const reader = new FileReader();

		    reader.onload = res => {
		    var base64String = window.btoa(res.target.result);
		    // names.push(file.name)
		      resolve(base64String);
		    };
		    reader.onerror = err => reject(err);

		    reader.readAsBinaryString(file);
		  });
		}

		async function read(file) {
			b64string = await readFile(file);
			console.log(b64string)

			_this.props.actions.getProtectedParams(_this.props.base.ausigUrl)
			.then((response) => {

				if (response !== null && response.contentType === "application/ccs.api.error+json;charset=UTF-8") {
					_this.props.actions.setGlobalProcessing(false)
					_this.props.actions.setErrorData(response.json)
					_this.props.actions.setShowErrorPopup(true)
					return;
				}

				const cleaned = _this.props.verifyDSReducer.macPasses.trim();
				const myArray = cleaned.split(" ");
				var jsonObject = {
		        	"macPasswords" : myArray
			    }

			    var cipherResult = cipher(jsonObject, response.publicKeyTextual, response.currentUtcDateTime);

			    var data = {
			        "encryptedData": cipherResult.encryptedData,
			        "secretKey": cipherResult.secretKey,
			        "pdfData": b64string
			    }

			    _this.props.actions.verifierFull(_this.props.base.ausigUrl, data)
			    .then((response) => {
			    	if (response !== null && response.contentType === "application/ccs.api.error+json;charset=UTF-8") {
						_this.props.actions.setGlobalProcessing(false)
						_this.props.actions.setErrorData(response.json)
						_this.props.actions.setShowErrorPopup(true)
						return;
					}

					if (response.length === 0) {
						var errorMeassage = i18next.t("emptyArray")

						var message = {
							message: errorMeassage
						}

						_this.props.actions.setGlobalProcessing(false)
						_this.props.actions.setErrorData(message)
						_this.props.actions.setShowErrorPopup(true)
						return;
					}

			    	var indexiesArray = [];
			    	var withAuSigVerificationResultArray = [];
			    	var showedArray = []

			    	// eslint-disable-next-line
			    	response.map((element, index) => {
			    		if (element.auSigVerificationResult !== null) {
			    			indexiesArray.push(index)
			    			withAuSigVerificationResultArray.push(element.auSigVerificationResult)
			    			showedArray.push("")
			    		}
			    	})

			    	_this.props.actions.setVerifyResultsArray(response)
			    	_this.props.actions.setIndexiesArray(indexiesArray)
					_this.props.actions.setWithAuSigVerificationResultArray(withAuSigVerificationResultArray)
					_this.props.actions.setShowedObjectsArray(showedArray)
			    	_this.props.actions.setGlobalProcessing(false)
				    console.log(response)
			    })
			})
		}

		read(this.props.verifyDSReducer.inputData)
	}

	componentDidMount () {
		document.addEventListener('keyup', this.keyUpHandler);
    }

    componentDidUpdate(prevProps) {

	}

	componentWillUnmount () {
		document.removeEventListener('keyup', this.keyUpHandler);
  	}

  	keyUpHandler(refName, e) {
		if (e.keyCode === 13) {
			var element = document.getElementById("confirmVerifyDS");
			element.click()
		}
  	}

	isEmpty(obj) {
	  for (const prop in obj) {
	    if (Object.hasOwn(obj, prop)) {
	      return false;
	    }
	  }

	  return true;
	}

	render() {
		const isVerifyDSEnabled = (this.props.verifyDSReducer.inputData !== null && this.props.verifyDSReducer.macPasses.length > 0 && this.props.base.globalProcessing === false) ? true : false
		return (
			<div className="row">

				<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{paddingTop: "10px"}}>
					<div className="card">
						<div className="card-header">
						    {i18next.t("verifyDSTitle")}
						</div>
						<div className="card-body">
							<div className="row no-left-right-padding">
								<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("signedFilePdf")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

	                                	{
	                              			<Dropzone ref={dropzoneDocRef} disabled={this.props.base.globalProcessing ? true : false} onDrop={this.handleOnDropData} accept=".pdf" multiple={false}>
						                        {({getRootProps, getInputProps}) => (
						                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropFile">
						                                <input {...getInputProps()} />
						                                <p style={{cursor: "pointer", marginTop: "16px"}}>{this.props.verifyDSReducer.inputData !== null ? this.props.verifyDSReducer.inputData.name : i18next.t("dragNDropTitle")}</p>
						                            </div>
						                        )}
						                    </Dropzone>
	                              		}

			                        </div>
			                        <input id="fileInputUpload" type="file" style={{"display": "none"}} />
			                    </div>
			                </div>

			                <div className="row no-left-right-padding">
								<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
	                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("macPasses")}</label>
	                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

	                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.verifyDSReducer.macPasses} onChange={this.handleMacPassesChanged} />

			                        </div>
			                    </div>
			                </div>

			                <div className="row no-left-right-padding">
								<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
									{
										this.props.verifyDSReducer.withAuSigVerificationResultArray
										? <div>
											{
												this.props.verifyDSReducer.withAuSigVerificationResultArray.map((result, index) => {
													return (
														<div className="row card-style-border" style={{marginTop: "10px", paddingTop: "10px", paddingBottom: "10px"}}>
															<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 img-container" style={{textAlign: "center"}}>
																<img src={"data:image/png;base64," + result.auSignatureImageData} alt="" />
															</div>
															<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
																<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding" style={{color: "#444"}}>
																	<div><span className="font-weight-bold">{i18next.t("HWDS")}</span><span>{result.isValid ? i18next.t("heIsValid") : i18next.t("heIsInvalid")}</span></div>
																</div>
																{
																	result.auSignerCommonName
																	? <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding" style={{color: "#444"}}>
																		<div><span className="font-weight-bold">{i18next.t("auSignerCommonName")}</span><span>{result.auSignerCommonName}</span></div>
																	</div>
																	: null
																}
																
																{
																	result.signingDateTime
																	? <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding" style={{color: "#444"}}>
																			<div><span className="font-weight-bold">{i18next.t("signingDateTimeHWDS")}</span><span>{this.props.actions.formatDate(result.signingDateTime)}</span></div>
																		</div>
																	: null
																}
																
																{
																	!this.isEmpty(result.arbitraryData)
																	? <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding" style={{color: "#444"}}>
																			<div><span className="font-weight-bold">{i18next.t("arbitraryData")}</span><span>{result.arbitraryData}</span></div>
																		</div>
																	: null
																}
																<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-right-padding ds-dropdown-style">
																	<div className="pointer border-top-style" style={{ display: 'flex', alignItems: 'center', color: "#777" }} value={index} onClick={this.changeShowedState.bind(this, index)}>
																		<span className="font-weight-bold">{i18next.t("signature")}</span>
																		<span style={{ marginLeft: '10px', fontColor: "#888" }}>
																			{this.props.verifyDSReducer.verifyResultsArray[this.props.verifyDSReducer.indexiesArray[index]].isValid
																				? i18next.t("heIsValid")
																				: i18next.t("heIsInvalid")}
																		</span>
																		<span style={{ marginLeft: 'auto' }}>
																			{
																				this.props.verifyDSReducer.showedObjectsArray[index] === ""
																				? <i className="fa fa-chevron-down" aria-hidden="true"></i>
																				: <i className="fa fa-chevron-up" aria-hidden="true"></i>
																			}
																		</span>
																	</div>
																	{
																		this.props.verifyDSReducer.showedObjectsArray[index] !== ""
																		? <div className="row no-left-right-padding" style={{color: "#777"}}>
																			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
																				<div><span className="font-weight-bold">{i18next.t("signer")}</span><span>{this.props.verifyDSReducer.verifyResultsArray[this.props.verifyDSReducer.indexiesArray[index]].signerCertificateInfo.subject.commonName}</span></div>
																			</div>
																			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
																				<div><span className="font-weight-bold">{i18next.t("organizationName")}</span><span>{this.props.verifyDSReducer.verifyResultsArray[this.props.verifyDSReducer.indexiesArray[index]].signerCertificateInfo.subject.organisationName}</span></div>
																			</div>
																			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
																				<div><span className="font-weight-bold">{i18next.t("ca")}</span><span>{this.props.verifyDSReducer.verifyResultsArray[this.props.verifyDSReducer.indexiesArray[index]].signerCertificateInfo.issuer.commonName}</span></div>
																			</div>
																			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
																				<div><span className="font-weight-bold">{i18next.t("signingDateTime")}</span><span>{this.formatDateDS(this.props.verifyDSReducer.verifyResultsArray[this.props.verifyDSReducer.indexiesArray[index]].signingDateTime)}</span></div>
																			</div>
																			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
																				<div><span className="font-weight-bold">{i18next.t("isElectronicStampTitle")}</span><span>{this.props.verifyDSReducer.verifyResultsArray[this.props.verifyDSReducer.indexiesArray[index]].signerCertificateInfo.extensions.isElectronicStamp ? i18next.t("yesUCase") : i18next.t("noUCase")}</span></div>
																			</div>
																			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
																				<div><span className="font-weight-bold">{i18next.t("QSCDTitle")}</span><span>{this.props.verifyDSReducer.verifyResultsArray[this.props.verifyDSReducer.indexiesArray[index]].signerCertificateInfo.extensions.isPrivateKeyOnQSCD ? i18next.t("yesUCase") : i18next.t("noUCase")}</span></div>
																			</div>
																			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
																				<div><span className="font-weight-bold">{i18next.t("QSCDTypeTitle")}</span><span>{this.props.verifyDSReducer.verifyResultsArray[this.props.verifyDSReducer.indexiesArray[index]].signerCertificateInfo.extensions.qscdTypeName}</span></div>
																			</div>
														                </div>
														                : null
																	}
																</div>

																
																
															</div>
														</div>
													)
												})
											}
										  </div>
										: null
									}
			                    </div>
			                </div>

			                <div className="row no-left-right-padding" style={{paddingTop: "10px"}}>
								<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
	                                <button id="confirmVerifyDS" className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isVerifyDSEnabled} onClick={this.verifyDS.bind(this)} >{i18next.t("verify")}</button>
			                    </div>
			                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
	                                <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={this.props.base.globalProcessing ? true : false} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUp")}</button>
			                    </div>
			                </div>

						</div>
					</div>
				</div>
				{
					this.props.base.globalProcessing
					? <div className='popup-dark'>
						<div className="loading-div-inner">
							<i className="fa fa-spinner fa-pulse"></i>
						</div>
					  </div>
					: null
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        verifyDSReducer: state.verifyDSReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	setVerifyInputData, setMacPasses, verifierFull,
    	getProtectedParams, setGlobalProcessing, cipher,
    	setVerifyResultsArray, setIndexiesArray, setWithAuSigVerificationResultArray,
    	formatDate, setShowedObjectsArray, setShowErrorPopup, setErrorData
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyDSView);